import { Paper } from "@mantine/core";
import { HiOutlineArrowUpTray } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { Headers } from "../components/ui/heading";
import CustomButton from "../components/ui/CustomButton/CustomButton";
import BulkUploadsPage from "../components/BulkUploads/BulkUploadsPage";
import useUserRole from "../components/Transactions/hooks/useUserRole";

function BulkUploads() {
  const navigate = useNavigate();
  const { isSuperAdmin } = useUserRole();

  return (
    <div className="-m-4 min-h-screen flex flex-col pb-16 bg-white-700">
      <Paper shadow="xs" p={{ base: "sm", sm: "xl" }}>
        <div className="flex-shrink-0 [&>div]:mb-0">
          <Headers
            name={
              <span className="text-gray-600 text-base">
                PAYMENTS {" > "} BATCH HISTORY
              </span>
            }
            subtitle={
              <span className="text-gray-900 capitalize text-lg font-bold">
                batch history
              </span>
            }
            actions={
              isSuperAdmin ? null : (
                <div className="flex items-center gap-2">
                  <CustomButton
                    radius="md"
                    onClick={() => navigate("/bulkpayments/manual-entry")}
                  >
                    Manual Entry
                  </CustomButton>
                  <CustomButton
                    radius="md"
                    color="gray"
                    leftSection={<HiOutlineArrowUpTray className="text-base" />}
                    onClick={() => navigate("/bulkpayments/file-upload")}
                  >
                    Upload File
                  </CustomButton>
                </div>
              )
            }
          />
        </div>
      </Paper>
      <BulkUploadsPage isSuperAdmin={isSuperAdmin} />
    </div>
  );
}

export default BulkUploads;
